import Vue from 'vue';
import { Component, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { DisplayOptions } from '@/types/store-types';

const project = namespace('project');

@Component({ components: {} })
export default class TaskHeaderComponent extends Vue {
  @project.Getter('allWeeksClosed')
  private allWeeksClosed: boolean;

  @project.Getter('displayOptions')
  private displayOptions: DisplayOptions;

  @project.Action('closeAllWeeks')
  private closeAllWeeks(close: boolean) {
  }

  get Title(): string {
    return this.allWeeksClosed ? this.$t('projectgeneral.openWeeks').toString() : this.$t('projectgeneral.closeWeeks').toString();
  }

  private closeWeeks() {
    this.closeAllWeeks(!this.allWeeksClosed);
  }
}
